require('./bootstrap');

window.Notiflix = require('notiflix/src/notiflix');